import styled from '@emotion/styled';

import { Button } from 'components/buttons';
import { ButtonWithLoading } from 'components/buttons/buttonWithLoading';
import IconChevron from 'components/icons/chevron';

export const ExpandSectionHandle = styled(Button)((_) => ({
  width: '100%',
  padding: '10px 10px',
  span: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
}));

export const ExpandSectionIcon = styled(IconChevron)<{ isExpanded: boolean }>(({ theme, isExpanded }) => ({
  height: 20,
  width: 20,
  transform: isExpanded ? 'rotate(0deg)' : 'rotate(180deg)',
  transition: 'transform 0.2s ease-in-out',
  marginLeft: 'auto',
  path: {
    fill: theme.colors.primary,
  },
}));

export const Header = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: 14,
  fontWeight: 500,
}));

export const Item = styled.div((_) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 10,
  width: '100%',
  fontSize: 13,
}));

export const CollapseContent = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 10,
}));

export const StyledButton = styled(ButtonWithLoading)(({ theme }) => ({
  span: {
    color: `${theme.colors.error.main}!important`,
  },
}));

export const ErrorText = styled.div((props) => ({
  color: props.theme.colors.error.main,
  fontSize: 12,
}));
